<template>
  <div class="content">
    <p class="title">失联信息</p>
    <div class="missing-info">
      <el-table ref="table" class="simple-table" :data="missingList" height="100%" highlight-current-row fit border>
        <el-table-column v-if="isOwner === true" prop="signingTime" label="业主" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="startTime" label="场地" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="endTime" label="表计号" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proprietorTransactorNickname" label="租户" align="left" min-width="160" show-overflow-tooltip></el-table-column>
        <el-table-column prop="proprietorTransactorNickname" label="最后一次通信时间" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'missingInformation',
  props: {
    isOwner: {
      type: Boolean,
      default: true
    },
    missingList: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 100%;
  color: #333;
  .title {
    text-align: left;
    font-size: 24px;
    font-weight: bold;
    color: #333;
  }
  .missing-info {
    width: 100%;
    height: calc(100% - 40px);
  }
}
</style>
